import { strDelimited } from "../../helper/split";

// DATA STRUCTURE: {partNumber: string, name: string, rowSpan: number}[];
function PartBufferData(dataParams) {
  this.id = dataParams.id || '';
  this.type = "part_IBIS";
  this.partNumber = dataParams.partNumber || '';
  this.file = dataParams.file || '';
  this.libraryId = dataParams.libraryId || '';
  this.component = dataParams.component || '';
  this.pin = dataParams.pin || '';
  this.signalType = dataParams.signalType || '';
  this.speed = dataParams.speed || '';
  this.txModel = dataParams.txModel || {};
  this.rxModel = dataParams.rxModel || {};
}

function mergePartBufferLibraryList(list, isSort) {
  if (!list || !list.length) {
    return [];
  }
  if (isSort) {
    list.sort((a, b) => a.partNumber.localeCompare(b.partNumber));
  }

  let rowSpan = 0, startIndex = 0, startPart = list[0].partNumber;
  for (let i = 0; i < list.length; i++) {
    if (list[i].partNumber !== startPart || !startPart) {
      list[startIndex].rowSpan = rowSpan;
      rowSpan = 1;
      startPart = list[i].partNumber;
      startIndex = i;
      continue;
    }

    list[i].rowSpan = 0;
    rowSpan++;
  }

  list[startIndex].rowSpan = rowSpan;
  return list;
}


class ModelSelectHelper {
  static getModelSelectorListList(selectorModels) {
    return this.getDataList(selectorModels, 'selector');
  }

  //get modelType list
  static getModelTypeList(modelList) {
    return this.getDataList(modelList, 'type');
  }

  static getDataList(list, key) {
    const data = list.map(item => item[key]).filter(it => !!it);
    const filterData = [...new Set(data)];
    return filterData.map(item => ({ label: item, value: item }));
  }

  static getSortedList(modelsObj) {
    let list = [];
    if (modelsObj && modelsObj.models) {
      const modelList = JSON.parse(JSON.stringify(modelsObj.models));
      const selectorModels = modelsObj.selectorModels ? JSON.parse(JSON.stringify(modelsObj.selectorModels)) : [];
      let selectorModelList = []
      for (let item of selectorModels) {
        if (item.models) {
          for (let model of item.models) {
            selectorModelList.push({ selector: item.selector, ...model });
          }
        }
      }
      for (let item of modelList) {
        const find = selectorModelList.find(model => model.name === item.name);
        if (find) {
          list.push({ ...find, ...item });
        } else {
          list.push({ ...item });
        }
      }
    }
    return list;
  }

  static filterModelNameList({ modelList, modelType, modelSelector, modelName, modelNameStr }) {
    let list = [...modelList];
    if (modelType) {
      list = modelList.filter(item => item.type === modelType);
    }

    if (modelSelector) {
      list = modelList.filter(item => item.selector === modelSelector);
    }

    if (modelName) {
      let reg = new RegExp(`(${modelName})`, 'i');
      list = list.filter(item => {
        if (item.info) {
          if (item.info.match(reg)) {
            return true;
          }
        } else if (item.name && item.name.match(reg)) {
          return true;
        }
        return false
      })
    }

    if (modelNameStr) {
      let value = modelNameStr;
      let valueList = [];
      strDelimited(value).forEach(item => {
        if (item.match(/(\[)|(\])|(\\)|(\/)|(\()|(\))|(\|)|(\?)/)) {
          item = `\\${item}`;
        }
        valueList.push(item)
      })
      value = valueList.join("");
      let reg = new RegExp(`(${value})`, 'i');
      list = list.filter(item => {
        if (item.info) {
          if (item.info.match(reg)) {
            return true;
          }
        } else if (item.name && item.name.match(reg)) {
          return true;
        }
        return false
      })
    }

    return list;
  }

  static existEnableVoltage(modelType) {
    const _type = modelType.toUpperCase();
    if (_type.includes('I/O') || _type.includes('IO') || _type === 'TRISTATE' || _type === '3-STATE' || _type === '3STATE') {
      return true;
    };
    return false;
  }
}

function checkFileAndModelName(checkFiles, fileName, modelName) {
  if (checkFiles.includes(fileName)) {
    return "The file is not uploaded to the library.";
  }

  const fileStr = [fileName, modelName].join('::');
  const find = checkFiles.find(item => item === fileStr);
  if (find) {
    return "The model is not in the file.";
  }
}

export {
  mergePartBufferLibraryList,
  ModelSelectHelper,
  PartBufferData,
  checkFileAndModelName
}